import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@alterrego/core-ui';
import tenantConfig from '../tenant.config.json';
import type { TenantConfig } from '@alterrego/core-config';
import { HomeScreen } from './screens/HomeScreen';
import { AgendaScreen } from './screens/AgendaScreen';
import { ExplorerScreen } from './screens/ExplorerScreen';
import { AuQuotidienScreen } from './screens/AuQuotidienScreen';
import { PlaceholderScreen } from './screens/PlaceholderScreen';

const config = tenantConfig as TenantConfig;

export default function App() {
  return (
    <ThemeProvider config={config}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/agenda" element={<AgendaScreen />} />
          <Route path="/explorer" element={<ExplorerScreen />} />
          <Route path="/au-quotidien" element={<AuQuotidienScreen />} />
          <Route path="/transports" element={<PlaceholderScreen title="Transports & navettes" icon="🚌" />} />
          <Route path="/actualites" element={<PlaceholderScreen title="Actualités" icon="📰" />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
